import React, { Fragment } from "react";
import { Link } from "react-router-dom";
import { toast } from "react-toastify";
import axios from "axios";
const GroupItemThree = ({ groups = [], itemNumber = 10, onGroupDeleted }) => {
  const GroupList = groups.slice(0, itemNumber);

  const handleDeleteGroup = async (groupId) => {
    const token = localStorage.getItem("token");

    if (!window.confirm("Are you sure you want to delete this group?")) return;

    try {
      await axios.delete(
        `${process.env.REACT_APP_MAIN_SITE_URL}/group/delete/${groupId}`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );

      toast.success("Group deleted successfully!");

      if (onGroupDeleted) onGroupDeleted();
    } catch (err) {
      console.error("Failed to delete group", err);
      toast.error("Delete failed");
    }
  };

  return (
    <Fragment>
      {GroupList.map((val, i) => (
        <div className="col-lg-6" key={i}>
          <div className="group-item lab-item style-1">
            <div className="lab-inner d-flex flex-wrap align-items-center p-4 position-relative">
              {/* Delete Button - Added to the top right */}

              {val.isCanDelete && (
                <button
                  className="group-delete-btn"
                  onClick={() => handleDeleteGroup(val.id)}
                >
                  <i className="icofont-trash"></i>
                </button>
              )}

              <div className="lab-thumb me-sm-4 mb-4 mb-sm-0">
                <img
                  src={val.image || "assets/images/group/07.jpg"}
                  alt={val.name}
                />
              </div>
              <div className="lab-content">
                <h4>{val.name}</h4>
                <p>{val.description}</p>

                <ul className="img-stack d-flex">
                  {val.members.map((member, i) => (
                    <li key={i}>
                      <img
                        src={member.imgUrl}
                        alt={member.name}
                        className="rounded-circle inherit-img-height"
                        width="40"
                      />
                    </li>
                  ))}
                  {val.moreCount && (
                    <li
                      className="bg-theme d-flex align-items-center justify-content-center text-white rounded-circle"
                      style={{ width: "40px", height: "40px" }}
                    >
                      {val.moreCount}
                    </li>
                  )}
                </ul>

                <div className="test">
                  <Link
                    to="/group"
                    state={{ groupId: val.id }}
                    className="lab-btn"
                  >
                    <i className="icofont-users-alt-5"></i> Show Group
                  </Link>
                </div>
              </div>
            </div>
          </div>
        </div>
      ))}
    </Fragment>
  );
};

export default GroupItemThree;
